import type { MutationFunction } from '@tanstack/react-query';
import type { AxiosInstance, AxiosResponse } from 'axios';
import { useDownloadEvents, useMessageEvents } from '@gov-nx/core/events';
import { LocalizeNameSpaceTypes, useLocale } from '@gov-nx/core/service';
import { createUuid4 } from '@gov-nx/utils/common';
import { useDownloadPoMutation } from '..';

export const useQueryDownload = <
	Variables extends { id?: string; axiosInstance: AxiosInstance },
>(
	mutationFn: MutationFunction<AxiosResponse, Variables>,
	options?: {
		onDownloadSuccess?: () => void;
	}
) => {
	const { download } = useDownloadEvents();
	const { toastMessageSuccess, toastMessageError } = useMessageEvents();
	const { t } = useLocale(LocalizeNameSpaceTypes.Service);

	const downloadMutation = useDownloadPoMutation(mutationFn, {
		onSuccess: (props) =>
			download({
				id: props.variables.id ?? createUuid4('download'),
				...props,
				callback: (_, success, error) => {
					if (success) {
						options?.onDownloadSuccess?.();
						toastMessageSuccess(
							t('dokument.stazeni-dokumentu-uspech', {
								fileName: props.fileName,
							})
						);
					}
					if (error) {
						toastMessageError();
					}
				},
			}),
	});

	return {
		download: (variables: Variables) => downloadMutation.mutate(variables),
		isDownloading: downloadMutation.isLoading,
	};
};
